import { BRAND_FAMILY, BRAND_MODULE, environmentLabel } from '../../lib/brand'

/**
 * The product identity on an unauthenticated screen.
 *
 * Sign in, password recovery and invitation acceptance are the first thing a
 * new user sees, and until now all three said `gdi-labour`, which is the
 * anchor customer's initials and the repository name rather than the product.
 *
 * The environment is named here too. Somebody signing in to a sandbox should
 * know before they type a password, not after they wonder why the numbers look
 * unfamiliar.
 */
export default function AuthBrand({ environment }: { environment: string }) {
  const label = environmentLabel(environment)
  return (
    <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1" data-testid="auth-brand">
      <span className="wordmark text-[1.05rem] font-bold tracking-[0.08em] text-steel-2">
        {BRAND_FAMILY}
      </span>
      <span className="wordmark text-[0.75rem] font-semibold uppercase tracking-[0.14em] text-amber-ink">
        {BRAND_MODULE}
      </span>
      {label !== null && (
        <span
          data-testid="auth-environment"
          className="wordmark ml-auto rounded-[4px] border border-line bg-surface-subtle px-2 py-0.5 text-[0.6875rem] font-semibold tracking-wide text-ink-muted"
        >
          {label}
        </span>
      )}
    </div>
  )
}
